import { useState } from "react";
import { hdmgdjFaqs } from "@/mocks/hdmgdj/faq";

interface HdmgdjFaqProps {
  id?: string;
  eyebrow?: string;
  title?: string;
  description?: string;
}

export default function HdmgdjFaq({
  id = "hdmgdj-faq",
  eyebrow = "常见问题",
  title = "关于 黄豆魔改短剧 你想知道的",
  description = "如果下面的解答没有帮到你，欢迎通过页尾的联系邮箱与我们取得联系，我们会尽快回复。",
}: HdmgdjFaqProps) {
  const [openId, setOpenId] = useState<string>(hdmgdjFaqs[0].id);

  const toggle = (itemId: string) => {
    setOpenId((current) => (current === itemId ? "" : itemId));
  };

  return (
    <section id={id} className="w-full bg-background-50 py-16 md:py-24">
      <div className="hdmgdj-container">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.4fr] gap-10 lg:gap-14">
          <div className="hdmgdj-reveal">
            <span className="inline-flex items-center gap-2 text-primary-700 text-[14px] font-label font-bold">
              <i className="ri-question-line text-lg" />
              {eyebrow}
            </span>
            <h2 className="mt-3 font-heading text-foreground-950 text-[32px] md:text-[42px] leading-tight">
              {title}
            </h2>
            <p className="mt-4 text-[15px] leading-8 text-foreground-600">{description}</p>
          </div>

          <div className="hdmgdj-reveal divide-y divide-background-200 border-t border-background-200">
            {hdmgdjFaqs.map((item) => {
              const open = openId === item.id;
              return (
                <div key={item.id}>
                  <button
                    type="button"
                    onClick={() => toggle(item.id)}
                    aria-expanded={open}
                    className="w-full flex items-start justify-between gap-4 py-5 text-left cursor-pointer"
                  >
                    <span className="text-[16px] font-bold font-label text-foreground-950">
                      {item.q}
                    </span>
                    <span
                      className={`w-7 h-7 flex items-center justify-center rounded-full shrink-0 transition-colors ${
                        open ? "bg-primary-500 text-foreground-950" : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className={open ? "ri-subtract-line" : "ri-add-line"} />
                    </span>
                  </button>
                  {open && (
                    <p className="pb-5 -mt-1 text-[14px] leading-7 text-foreground-600 max-w-2xl">
                      {item.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}